import React, { useEffect, useState } from 'react';
import Navigation from "../Navigation/Navigation";
import Footer from "../General/Footer";
import Form from 'react-bootstrap/Form';
import StarRatings from 'react-star-ratings';
import placeholder from "../../assets/badges/avatar.jpg";
import { useParams, Link } from "react-router-dom";

// Replace these with your actual API calls
import { getUserProfile, getMyRides } from "../../actions/userProfileActions";

export default function OwnerPage(props) {

    const { ownerId } = useParams();       // URL: /owner/:ownerId
    const [owner, setOwner] = useState(null);
    const [rides, setRides] = useState([]);
    const [loading, setLoading] = useState(true);

    // Load Owner Profile + Rides
    useEffect(() => {
        let token = props.auth?.token;

        async function loadData() {
            try {
                const resOwner = await getUserProfile({ userId: ownerId }, token);
                const resRides = await getMyRides({ userId: ownerId }, token);

                setOwner(resOwner.data || {});
                setRides(resRides.data || []);
            } catch (err) {
                console.log("Error loading owner:", err);
            } finally {
                setLoading(false);
            }
        }

        loadData();
    }, [ownerId, props.auth]);

    // Show loading spinner
    if (loading) {
        return (
            <div className="ownerpage__main">
                <Navigation auth={props.auth} />
                <div className="loading">Loading...</div>
            </div>
        );
    }

    if (!owner) {
        return (
            <div className="ownerpage__main">
                <Navigation auth={props.auth} />
                <div className="error">Owner not found.</div>
            </div>
        );
    }

    return (
        <div className="ownerpage__main">
            <Navigation auth={props.auth} />

            {/* PAGE HERO */}
            <div className="page__hero">
                <h4 className="page-title page__hero__title">Owner Profile</h4>
            </div>

            <div className="ownerpage__container">
                <div className="ownerpage__fields__container">

                    {/* Verified Checkmark */}
                    <span className="ownerpage__verified"><i className="fas fa-check"></i></span>

                    {/* PROFILE IMAGE */}
                    <div className="ownerpage__image">
                        <img src={owner.image || placeholder} alt="Owner Profile" />
                    </div>

                    {/* NAME */}
                    <div className="ownerpage__name">
                        {owner.firstName} {owner.lastName}
                    </div>

                    {/* DESCRIPTION */}
                    <div className="ownerpage__description">
                        {owner.description || "No description provided."}
                    </div>

                    {/* GRID: LOCATION + RATING */}
                    <div className="ownerpage__grid">
                        <div className="ownerpage__location">
                            <i className="fas fa-map-marker-alt"></i>
                            {owner.fullAddress || "Unknown location"}
                        </div>

                        <div className="ownerpage__rating">
                            <StarRatings
                                rating={owner.rating || 0}
                                starRatedColor="#0888be"
                                starDimension="18px"
                                starSpacing="1px"
                            />
                        </div>
                    </div>

                    {/* RIDES LIST */}
                    <hr />
                    <Form.Label className="createride__category__title">My Rides</Form.Label>

                    <div className="ownerpage__rides">
                        <div className="ownerpage__rides__list">

                            {rides.length === 0 && (
                                <div className="empty">This owner has no rides yet.</div>
                            )}

                            {rides.map((ride) => (
                                <div key={ride.id} className="ownerpage__rides__item">
                                    <Link to={`/ride/${ride.id}`}>
                                        <img src={ride.images || placeholder} alt="Ride" />
                                    </Link>
                                    <div className="ownerpage__rides__info">
                                        <div className="ownerpage__rides__title">
                                            {ride.title}
                                        </div>
                                        <div className="ownerpage__rides__subtitle">
                                            {ride.subtitle}
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    );
}
